
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as confirmationiNTlB_ajD1qGPFhPZP5sui9XcruQRxt_P85y121GwokMeta } from "/app/app/pages/auth/forgot-password/confirmation.vue?macro=true";
import { default as set_45password5NA6_wf5y_we9i23b9x1bpoHjrgh7GR4sJnKyLajGzcMeta } from "/app/app/pages/auth/forgot-password/set-password.vue?macro=true";
import { default as verify_45codeDC2_Uv6dX27d0JhhSrW9XYHDeOoZGbnRBZ6L_y_oTtQMeta } from "/app/app/pages/auth/forgot-password/verify-code.vue?macro=true";
import { default as email7ON0ogDhM28jkJKWPZ5BBqNMFb3Me8WwF_mFINrrX3sMeta } from "/app/app/pages/auth/login/email.vue?macro=true";
import { default as emailNCW0cJ8YQbG36fDVjk__UI8nR1A1yty5Nh4V_tgG9iwMeta } from "/app/app/pages/auth/register/email.vue?macro=true";
import { default as investor_45profile8SFyFl38HR6_OBJe5ntggI7PcQLBsPJe7QY9mO839yUMeta } from "/app/app/pages/deprecated/accounts/investor-profile.vue?macro=true";
import { default as overviewautaACb0RR12ZFJpN7_F8aSQhcz0we4w8ZazMNyNJywMeta } from "/app/app/pages/deprecated/experimental/overview.vue?macro=true";
import { default as p1BwQ72TyMTncODQB0MynH8ZjbOkD3fq6JOlOT2fnhETYMeta } from "/app/app/pages/experimental/swipe-nav/p1.vue?macro=true";
import { default as p2IqZHTc88Qjl18DtxxZHVIyLM6EC_tZn5XFWaXxdOAKsMeta } from "/app/app/pages/experimental/swipe-nav/p2.vue?macro=true";
import { default as p3iqNRY8ZMH_EPb0KRtT11tKxqfu5HBo4Yh0bMTxHKBbMMeta } from "/app/app/pages/experimental/swipe-nav/p3.vue?macro=true";
import { default as swipe_45navDU05K18koA87G1F4lCjgqNgAx6Y8FwyVIqr6CopQlgcMeta } from "/app/app/pages/experimental/swipe-nav/swipe-nav.vue?macro=true";
import { default as _91account_id_93_gCfnDg2uD_pgpv4ookktq0yMGjdWCOZfAHfop4aKSkMeta } from "/app/app/pages/deprecated/positions/[account_id].vue?macro=true";
import { default as _91uuid_93QRYsqsfxzdqrM7jmaLE7UvnCZAWtd6mDZvug7qQ7CmAMeta } from "/app/app/pages/holdings/edit/[uuid].vue?macro=true";
import { default as connected_45banks3rS3AwRSHjK2nWvZ5at_gP2z12r3QsB6tRz5icNhRNQMeta } from "/app/app/pages/accounts/connected-banks.vue?macro=true";
import { default as settings1u2MKQS7NzkxEeCACkw2TvcCeKThc_DuNx0SN6uqzUwMeta } from "/app/app/pages/accounts/settings.vue?macro=true";
import { default as email_45verificationugXO56o0xXguqxNSqDGv9LBuEb3rEk1WZu1BSdhJ8loMeta } from "/app/app/pages/auth/email-verification.vue?macro=true";
import { default as index1X0OQA84Al7rbALodP8SG8VJXanyZcvqeosEfn_jKrgMeta } from "/app/app/pages/auth/forgot-password/index.vue?macro=true";
import { default as indexqctbeECbnudan0PQZK1rHbrGesJJF63Wo3KXzy46iy8Meta } from "/app/app/pages/auth/login/index.vue?macro=true";
import { default as indexPk7LgbW1SqAC2_Ty4yoM6s4qOmTz1nQs8u8_K_uxURQMeta } from "/app/app/pages/auth/register/index.vue?macro=true";
import { default as verifypG8nxiXPPbbPzYLZI91glw1dtN3BPuPfkSBm3LANRVEMeta } from "/app/app/pages/auth/verify.vue?macro=true";
import { default as verify_45emaildf7qcW2lS74ZzzWmkTOBVmemkXXxNv_krygNszJw6XIMeta } from "/app/app/pages/auth/verify-email.vue?macro=true";
import { default as welcome6muzwuFVRfYODJPqGx8prcN7AngtU2vRxemfrm6TipAMeta } from "/app/app/pages/auth/welcome.vue?macro=true";
import { default as analyticsL7J7qoNd4CyQB4XS0EvRbTMhrDUf7PzW6WA1wpVt2y0Meta } from "/app/app/pages/deprecated/analytics.vue?macro=true";
import { default as fund_45checkerQNZq9wJKEHitZ47_CsTsNDP34yUJ__faYYuReJHiUEkMeta } from "/app/app/pages/deprecated/fund-checker.vue?macro=true";
import { default as indext_2Q55Mu69jqTWtutOeOU1GIzUyoyM01Sehd5cN8LycMeta } from "/app/app/pages/deprecated/positions/index.vue?macro=true";
import { default as all_45viewsutYnNAHbIv7oKpLRjwXljLRGlEQNj6mzb_lVx95VpA0Meta } from "/app/app/pages/dev/all-views.vue?macro=true";
import { default as api_45callsAEUCNhRWD3gcQQ3HvOWmBJSrKZgtyCCTKRKE7kFw_NQMeta } from "/app/app/pages/dev/api-calls.vue?macro=true";
import { default as componentswCl_K1T0IwldfEBqsetl7F1PlQVKGrE8y3sz6ijxLb0Meta } from "/app/app/pages/dev/components.vue?macro=true";
import { default as debugULIHvAZLXNuQEQ0__58G_ENDOOv0elrXGDDNjoTnjloMeta } from "/app/app/pages/dev/debug.vue?macro=true";
import { default as historical_45mv_45analysisTPzkQ0DHsO9qORhzIJ9ULdCk822rn1Rw__yI45BswjkMeta } from "/app/app/pages/dev/historical-mv-analysis.vue?macro=true";
import { default as insights_45studioRLQ6V8TLjFS0dwzmb6UJG6_5_aFCW51WoHTwVBYxD9gMeta } from "/app/app/pages/dev/insights-studio.vue?macro=true";
import { default as monitoring_45studio7So0tklbay__ROWU2qbPly_2Q_JjKx_Hce_mpldVmwsMeta } from "/app/app/pages/dev/monitoring-studio.vue?macro=true";
import { default as prompt_45studioza0_DQ_y4y_txNvUC1wSZeNhG3x25dYEOyNm8Zt9ApkMeta } from "/app/app/pages/dev/prompt-studio.vue?macro=true";
import { default as ain93ROdqIcVBHeTXn5n_qxAI6AVsta5J9m83p4LEHyK0Meta } from "/app/app/pages/experimental/ai.vue?macro=true";
import { default as chart_45experimentsJZvH5aFNNB3bCEd4zN_why965ZTHPNXRBF9vKFoifMYMeta } from "/app/app/pages/experimental/chart-experiments.vue?macro=true";
import { default as detailed_45account_45viewJhK_qJ71B9j3TZUC6XdJR9_XoekSblD6w_qRUL_MQwIMeta } from "/app/app/pages/experimental/detailed-account-view.vue?macro=true";
import { default as financial_45planningUAHlmuiLApvQL3NB2dgCW_JzlrTDOpaQRrtcVrc9A9UMeta } from "/app/app/pages/experimental/financial-planning.vue?macro=true";
import { default as upload_45holdings_cLVL3WRz9CX95Isa45N6G_mn36b_7Prpzd_U6YEbIIMeta } from "/app/app/pages/experimental/upload-holdings.vue?macro=true";
import { default as newp99WWCP_j8r79b5f7fqf3ee0Q6gQGC6_1SJsv1dN49YMeta } from "/app/app/pages/goals/new.vue?macro=true";
import { default as listedT9OBPx2VgHWxCEFKJN5YYlCDuqBNwHRjmh0GZko_OFMMeta } from "/app/app/pages/holdings/add/listed.vue?macro=true";
import { default as adduUGsYgJIXxWUZluTCALFa_3_KJ3RgQNXzFXgi4PVDEMMeta } from "/app/app/pages/holdings/add.vue?macro=true";
import { default as newVrI6CBjU64wRjssYrU4jPllQNOg59doMOZCSfWLxNVcMeta } from "/app/app/pages/monitoring/new.vue?macro=true";
import { default as accountst0v8eQKUZN1bzXGMe0ZfZd1x_gJ4lAzoQ5Y0OUPbfMAMeta } from "/app/app/pages/setup/accounts.vue?macro=true";
import { default as edit13nbralvDtoA2zeMkXthwHMejlzYKf7mTWLXt0tyG_kMeta } from "/app/app/pages/goals/[id]/edit.vue?macro=true";
import { default as _91id_93HTo1sqLl2unddA12lJKTmS9VuhAltq7mAvzblpObXnQMeta } from "/app/app/pages/account/[id].vue?macro=true";
import { default as indexq8hXiTqQgqeVt9efvdH_7MKS7GK4QfV9AJt46e4iVIUMeta } from "/app/app/pages/goals/[id]/index.vue?macro=true";
import { default as index6ysNUDnmqcSQCYr_lsQce6SL9YFz4_vUPsCi53c2fpsMeta } from "/app/app/pages/accounts/index.vue?macro=true";
import { default as androidkj0wJf3JYM1TMzvGA_374GRvnpdlvX2wgPo0SveVNBEMeta } from "/app/app/pages/android.vue?macro=true";
import { default as diversification3E16W9e1uVSjiaiZDYkAR5UoHHLBSpgDHz_wmUZt5DgMeta } from "/app/app/pages/diversification.vue?macro=true";
import { default as indexUFN6ex0qNScw8u5VjP9HyW2bbyZTdcpqSljTbTbET_EMeta } from "/app/app/pages/goals/index.vue?macro=true";
import { default as homewCL8ohGwYXHZ_VFxToLGZta5J_Bjj6J02q_xQvczRHcMeta } from "/app/app/pages/home.vue?macro=true";
import { default as maintenanceB0dPhdEyV88_MoClqO_e6VO_RgGIumEnK1cdoU0zHTYMeta } from "/app/app/pages/maintenance.vue?macro=true";
import { default as index0oAsQqyeh_70giNhABOjBSZvl4mkU30ivqr7IRUa1ioMeta } from "/app/app/pages/monitoring/index.vue?macro=true";
import { default as overview1AAMNE54d_0Cq3wXsjFC8HY2kxeaALyDbhhpeGhq_REMeta } from "/app/app/pages/overview.vue?macro=true";
import { default as riskoZvgdapryWKqBNEdzJ3E9bDeG9OkED8fqxREuXiev4UMeta } from "/app/app/pages/risk.vue?macro=true";
import { default as settingsTWvHjpVkfjKsEMAblILOtSL39Q1Q7p_32B16g4gh6MIMeta } from "/app/app/pages/settings.vue?macro=true";
import { default as terms_45and_45conditionsHt9QKhr2DIOoRIzSJwy1_i6dlJp4HUrK1MN5NxTqG0YMeta } from "/app/app/pages/terms-and-conditions.vue?macro=true";
import { default as test_45linksWotDeDZ3WmNPxBvzy_Vu7mSjPsKI2e3o8CL6S6Ht0EMMeta } from "/app/app/pages/test-links.vue?macro=true";
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
export default [
  {
    name: "auth-forgot-password-confirmation",
    path: "/auth/forgot-password/confirmation",
    meta: confirmationiNTlB_ajD1qGPFhPZP5sui9XcruQRxt_P85y121GwokMeta || {},
    component: () => import("/app/app/pages/auth/forgot-password/confirmation.vue")
  },
  {
    name: "auth-forgot-password-set-password",
    path: "/auth/forgot-password/set-password",
    meta: set_45password5NA6_wf5y_we9i23b9x1bpoHjrgh7GR4sJnKyLajGzcMeta || {},
    component: () => import("/app/app/pages/auth/forgot-password/set-password.vue")
  },
  {
    name: "auth-forgot-password-verify-code",
    path: "/auth/forgot-password/verify-code",
    meta: verify_45codeDC2_Uv6dX27d0JhhSrW9XYHDeOoZGbnRBZ6L_y_oTtQMeta || {},
    component: () => import("/app/app/pages/auth/forgot-password/verify-code.vue")
  },
  {
    name: "auth-login-email",
    path: "/auth/login/email",
    meta: email7ON0ogDhM28jkJKWPZ5BBqNMFb3Me8WwF_mFINrrX3sMeta || {},
    component: () => import("/app/app/pages/auth/login/email.vue")
  },
  {
    name: "auth-register-email",
    path: "/auth/register/email",
    meta: emailNCW0cJ8YQbG36fDVjk__UI8nR1A1yty5Nh4V_tgG9iwMeta || {},
    component: () => import("/app/app/pages/auth/register/email.vue")
  },
  {
    name: "deprecated-accounts-investor-profile",
    path: "/deprecated/accounts/investor-profile",
    meta: { ...(investor_45profile8SFyFl38HR6_OBJe5ntggI7PcQLBsPJe7QY9mO839yUMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/deprecated/accounts/investor-profile.vue")
  },
  {
    name: "deprecated-experimental-overview",
    path: "/deprecated/experimental/overview",
    meta: { ...(overviewautaACb0RR12ZFJpN7_F8aSQhcz0we4w8ZazMNyNJywMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/deprecated/experimental/overview.vue")
  },
  {
    name: "experimental-swipe-nav-p1",
    path: "/experimental/swipe-nav/p1",
    component: () => import("/app/app/pages/experimental/swipe-nav/p1.vue")
  },
  {
    name: "experimental-swipe-nav-p2",
    path: "/experimental/swipe-nav/p2",
    component: () => import("/app/app/pages/experimental/swipe-nav/p2.vue")
  },
  {
    name: "experimental-swipe-nav-p3",
    path: "/experimental/swipe-nav/p3",
    component: () => import("/app/app/pages/experimental/swipe-nav/p3.vue")
  },
  {
    name: "experimental-swipe-nav-swipe-nav",
    path: "/experimental/swipe-nav/swipe-nav",
    component: () => import("/app/app/pages/experimental/swipe-nav/swipe-nav.vue")
  },
  {
    name: "deprecated-positions-account_id",
    path: "/deprecated/positions/:account_id()",
    meta: { ...(_91account_id_93_gCfnDg2uD_pgpv4ookktq0yMGjdWCOZfAHfop4aKSkMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/deprecated/positions/[account_id].vue")
  },
  {
    name: "holdings-edit-uuid",
    path: "/holdings/edit/:uuid()",
    meta: { ...(_91uuid_93QRYsqsfxzdqrM7jmaLE7UvnCZAWtd6mDZvug7qQ7CmAMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/holdings/edit/[uuid].vue")
  },
  {
    name: "accounts-connected-banks",
    path: "/accounts/connected-banks",
    meta: { ...(connected_45banks3rS3AwRSHjK2nWvZ5at_gP2z12r3QsB6tRz5icNhRNQMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/accounts/connected-banks.vue")
  },
  {
    name: "accounts-settings",
    path: "/accounts/settings",
    meta: { ...(settings1u2MKQS7NzkxEeCACkw2TvcCeKThc_DuNx0SN6uqzUwMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/accounts/settings.vue")
  },
  {
    name: "auth-email-verification",
    path: "/auth/email-verification",
    meta: email_45verificationugXO56o0xXguqxNSqDGv9LBuEb3rEk1WZu1BSdhJ8loMeta || {},
    component: () => import("/app/app/pages/auth/email-verification.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: index1X0OQA84Al7rbALodP8SG8VJXanyZcvqeosEfn_jKrgMeta || {},
    component: () => import("/app/app/pages/auth/forgot-password/index.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: indexqctbeECbnudan0PQZK1rHbrGesJJF63Wo3KXzy46iy8Meta || {},
    component: () => import("/app/app/pages/auth/login/index.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: indexPk7LgbW1SqAC2_Ty4yoM6s4qOmTz1nQs8u8_K_uxURQMeta || {},
    component: () => import("/app/app/pages/auth/register/index.vue")
  },
  {
    name: "auth-verify",
    path: "/auth/verify",
    meta: verifypG8nxiXPPbbPzYLZI91glw1dtN3BPuPfkSBm3LANRVEMeta || {},
    component: () => import("/app/app/pages/auth/verify.vue")
  },
  {
    name: "auth-verify-email",
    path: "/auth/verify-email",
    meta: verify_45emaildf7qcW2lS74ZzzWmkTOBVmemkXXxNv_krygNszJw6XIMeta || {},
    component: () => import("/app/app/pages/auth/verify-email.vue")
  },
  {
    name: "auth-welcome",
    path: "/auth/welcome",
    meta: welcome6muzwuFVRfYODJPqGx8prcN7AngtU2vRxemfrm6TipAMeta || {},
    component: () => import("/app/app/pages/auth/welcome.vue")
  },
  {
    name: "deprecated-analytics",
    path: "/deprecated/analytics",
    meta: { ...(analyticsL7J7qoNd4CyQB4XS0EvRbTMhrDUf7PzW6WA1wpVt2y0Meta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/deprecated/analytics.vue")
  },
  {
    name: "deprecated-fund-checker",
    path: "/deprecated/fund-checker",
    meta: { ...(fund_45checkerQNZq9wJKEHitZ47_CsTsNDP34yUJ__faYYuReJHiUEkMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/deprecated/fund-checker.vue")
  },
  {
    name: "deprecated-positions",
    path: "/deprecated/positions",
    meta: { ...(indext_2Q55Mu69jqTWtutOeOU1GIzUyoyM01Sehd5cN8LycMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/deprecated/positions/index.vue")
  },
  {
    name: "dev-all-views",
    path: "/dev/all-views",
    component: () => import("/app/app/pages/dev/all-views.vue")
  },
  {
    name: "dev-api-calls",
    path: "/dev/api-calls",
    component: () => import("/app/app/pages/dev/api-calls.vue")
  },
  {
    name: "dev-components",
    path: "/dev/components",
    component: () => import("/app/app/pages/dev/components.vue")
  },
  {
    name: "dev-debug",
    path: "/dev/debug",
    component: () => import("/app/app/pages/dev/debug.vue")
  },
  {
    name: "dev-historical-mv-analysis",
    path: "/dev/historical-mv-analysis",
    component: () => import("/app/app/pages/dev/historical-mv-analysis.vue")
  },
  {
    name: "dev-insights-studio",
    path: "/dev/insights-studio",
    component: () => import("/app/app/pages/dev/insights-studio.vue")
  },
  {
    name: "dev-monitoring-studio",
    path: "/dev/monitoring-studio",
    component: () => import("/app/app/pages/dev/monitoring-studio.vue")
  },
  {
    name: "dev-prompt-studio",
    path: "/dev/prompt-studio",
    component: () => import("/app/app/pages/dev/prompt-studio.vue")
  },
  {
    name: "experimental-ai",
    path: "/experimental/ai",
    meta: { ...(ain93ROdqIcVBHeTXn5n_qxAI6AVsta5J9m83p4LEHyK0Meta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/experimental/ai.vue")
  },
  {
    name: "experimental-chart-experiments",
    path: "/experimental/chart-experiments",
    component: () => import("/app/app/pages/experimental/chart-experiments.vue")
  },
  {
    name: "experimental-detailed-account-view",
    path: "/experimental/detailed-account-view",
    meta: {"middleware":"terms-accepted"},
    component: () => import("/app/app/pages/experimental/detailed-account-view.vue")
  },
  {
    name: "experimental-financial-planning",
    path: "/experimental/financial-planning",
    component: () => import("/app/app/pages/experimental/financial-planning.vue")
  },
  {
    name: "experimental-upload-holdings",
    path: "/experimental/upload-holdings",
    meta: { ...(upload_45holdings_cLVL3WRz9CX95Isa45N6G_mn36b_7Prpzd_U6YEbIIMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/experimental/upload-holdings.vue")
  },
  {
    name: "goals-new",
    path: "/goals/new",
    meta: { ...(newp99WWCP_j8r79b5f7fqf3ee0Q6gQGC6_1SJsv1dN49YMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/goals/new.vue")
  },
  {
    name: "holdings-add",
    path: "/holdings/add",
    meta: adduUGsYgJIXxWUZluTCALFa_3_KJ3RgQNXzFXgi4PVDEMMeta || {},
    component: () => import("/app/app/pages/holdings/add.vue"),
    children: [
  {
    name: "holdings-add-listed",
    path: "listed",
    meta: listedT9OBPx2VgHWxCEFKJN5YYlCDuqBNwHRjmh0GZko_OFMMeta || {},
    component: () => import("/app/app/pages/holdings/add/listed.vue")
  }
]
  },
  {
    name: "monitoring-new",
    path: "/monitoring/new",
    meta: { ...(newVrI6CBjU64wRjssYrU4jPllQNOg59doMOZCSfWLxNVcMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/monitoring/new.vue")
  },
  {
    name: "setup-accounts",
    path: "/setup/accounts",
    meta: { ...(accountst0v8eQKUZN1bzXGMe0ZfZd1x_gJ4lAzoQ5Y0OUPbfMAMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/setup/accounts.vue")
  },
  {
    name: "goals-id-edit",
    path: "/goals/:id()/edit",
    meta: { ...(edit13nbralvDtoA2zeMkXthwHMejlzYKf7mTWLXt0tyG_kMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/goals/[id]/edit.vue")
  },
  {
    name: "account-id",
    path: "/account/:id()",
    meta: { ...(_91id_93HTo1sqLl2unddA12lJKTmS9VuhAltq7mAvzblpObXnQMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/account/[id].vue")
  },
  {
    name: "goals-id",
    path: "/goals/:id()",
    meta: { ...(indexq8hXiTqQgqeVt9efvdH_7MKS7GK4QfV9AJt46e4iVIUMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/goals/[id]/index.vue")
  },
  {
    name: "accounts",
    path: "/accounts",
    meta: { ...(index6ysNUDnmqcSQCYr_lsQce6SL9YFz4_vUPsCi53c2fpsMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/accounts/index.vue")
  },
  {
    name: "android",
    path: "/android",
    meta: androidkj0wJf3JYM1TMzvGA_374GRvnpdlvX2wgPo0SveVNBEMeta || {},
    component: () => import("/app/app/pages/android.vue")
  },
  {
    name: "diversification",
    path: "/diversification",
    meta: { ...(diversification3E16W9e1uVSjiaiZDYkAR5UoHHLBSpgDHz_wmUZt5DgMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/diversification.vue")
  },
  {
    name: "goals",
    path: "/goals",
    meta: { ...(indexUFN6ex0qNScw8u5VjP9HyW2bbyZTdcpqSljTbTbET_EMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/goals/index.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: { ...(homewCL8ohGwYXHZ_VFxToLGZta5J_Bjj6J02q_xQvczRHcMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/home.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenanceB0dPhdEyV88_MoClqO_e6VO_RgGIumEnK1cdoU0zHTYMeta || {},
    component: () => import("/app/app/pages/maintenance.vue")
  },
  {
    name: "monitoring",
    path: "/monitoring",
    meta: { ...(index0oAsQqyeh_70giNhABOjBSZvl4mkU30ivqr7IRUa1ioMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/monitoring/index.vue")
  },
  {
    name: "overview",
    path: "/overview",
    meta: { ...(overview1AAMNE54d_0Cq3wXsjFC8HY2kxeaALyDbhhpeGhq_REMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/overview.vue")
  },
  {
    name: "risk",
    path: "/risk",
    meta: { ...(riskoZvgdapryWKqBNEdzJ3E9bDeG9OkED8fqxREuXiev4UMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/risk.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: { ...(settingsTWvHjpVkfjKsEMAblILOtSL39Q1Q7p_32B16g4gh6MIMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/settings.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    meta: terms_45and_45conditionsHt9QKhr2DIOoRIzSJwy1_i6dlJp4HUrK1MN5NxTqG0YMeta || {},
    component: () => import("/app/app/pages/terms-and-conditions.vue")
  },
  {
    name: "test-links",
    path: "/test-links",
    component: () => import("/app/app/pages/test-links.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {}), ...{"middleware":"terms-accepted"} },
    component: () => import("/app/app/pages/index.vue")
  }
]